import { useMemo, useState } from 'react';
import { List, TextField, EmailField, DateField, FunctionField, useTranslate } from 'react-admin';
import { CustomDatagrid, CrudListActions, RowActionsMenu } from '@/components/common';
import { compactListSx } from '@/components/common/compactListSx';
import {
  CollapsibleFilterPanel,
  FilterExpandContext,
} from '@/components/common/CollapsibleFilterPanel';
import { CustomTextInputFilter } from '@/components/common/CustomFilters';

export const AdminList = () => {
  const translate = useTranslate();
  const [filtersExpanded, setFiltersExpanded] = useState(false);
  const filterExpandValue = useMemo(
    () => ({ expanded: filtersExpanded, setExpanded: setFiltersExpanded }),
    [filtersExpanded]
  );

  const filters = useMemo(
    () => [
      <CollapsibleFilterPanel key="filters" source="_cfp" alwaysOn alwaysVisibleCount={0}>
        <CustomTextInputFilter
          source="q"
          label={translate('common.filters.search', { _: 'Buscar' })}
          alwaysOn
        />
      </CollapsibleFilterPanel>,
    ],
    [translate]
  );

  return (
    <FilterExpandContext.Provider value={filterExpandValue}>
      <List
        sx={compactListSx}
        filters={filters}
        actions={<CrudListActions exportColumns={['full_name', 'email', 'contact_no', 'status', 'last_login']} />}
        sort={{ field: 'user_id', order: 'DESC' }}
        exporter={false}
      >
        <CustomDatagrid primarySource="full_name" secondarySource="email" bulkActionButtons={false}>
          <RowActionsMenu label="" sortable={false} />
          <TextField source="full_name" />
          <EmailField source="email" />
          <TextField source="contact_no" />
          <FunctionField
            source="status"
            render={(record: any) =>
              record?.status === 1
                ? translate('common.status.active', { _: 'Activo' })
                : translate('common.status.inactive', { _: 'Inactivo' })
            }
          />
          <DateField source="last_login" showTime />
        </CustomDatagrid>
      </List>
    </FilterExpandContext.Provider>
  );
};

export default AdminList;
